module.exports = __webpack_public_path__ + "static/media/Twitter.b3cdd630.png";